/*
 * Heracles: make browser find-in-page (Ctrl/Cmd+F) reveal text inside collapsed accordions.
 *
 * Broadcast's accordions are <details data-collapsible> elements. When Chrome/Edge/Safari find
 * a match inside a closed <details>, they open it natively, but the theme's CSS keeps
 * [data-collapsible-body] at height:0 and only expands it when its own click handler sets
 * open="true". So the details is "open" yet the answer stays invisible.
 *
 * This listens for that native open (open attribute present but not "true") and finishes the
 * job the theme's click handler would have done, so the matched text is visible where the
 * browser highlights it. Clicks still go through the theme's own handler unchanged.
 */
(function () {
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.hasAttribute('data-collapsible')) return;
      if (!details.open || details.getAttribute('open') === 'true' || details.hasAttribute('disabled')) return;

      var body = details.querySelector('[data-collapsible-body]');
      details.setAttribute('open', 'true');
      if (body) body.style.height = 'auto';
    },
    true
  );
})();
